import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const HamburgerMenu = ({ criticisms }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="hamburger-menu">
      <button 
        className={`hamburger-button ${isOpen ? 'open' : ''}`}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <nav>
          <Link to="/" onClick={() => setIsOpen(false)}>Home</Link>
          <Link to="/about" onClick={() => setIsOpen(false)}>About</Link>
          <Link to="/contact" onClick={() => setIsOpen(false)}>Contact</Link>
          <div className="mobile-menu-divider"></div>
          {criticisms.map(criticism => (
            <Link 
              key={criticism.id}
              to={`/issue/${criticism.id}`}
              onClick={() => setIsOpen(false)}
            >
              {criticism.title}
            </Link>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default HamburgerMenu; 